import { randomIntFromInterval, randomItemFromList } from '~/bootcamp/Activities/utils/activities.utils'

import { getPatternsByDifficulty } from '~/bootcamp/Activities/PEMDAS/pemdas-patterns'

/**
 * Responsible to generate final term after adjustment and shuffle
 * @param difficultyLevel
 * @param taskHistory
 * @returns Equation and pattern
 */
export function generatePemdasEquation(
  difficultyLevel: number,
  taskHistory: string[],
): { equation: string; pattern: string } {
  const { patterns: patternList } = getPatternsByDifficulty(difficultyLevel)

  const selectedPatternStr = selectPatternFromPatternList(patternList, taskHistory)
  return { equation: makeEquationFromPattern(selectedPatternStr), pattern: selectedPatternStr }
}

/**
 * @param patternList
 * @param excludeArr
 * @returns selected random pattern
 */
export function selectPatternFromPatternList(patternList: string[], excludeArr: string[]): string {
  const index = Math.floor(Math.random() * patternList.length)
  const patternStr = patternList[index]

  if (excludeArr && excludeArr.includes(patternStr)) {
    return selectPatternFromPatternList(patternList, excludeArr)
  }

  return patternStr
}

/**
 * @param patternStr
 * @returns validated equation
 */
export function makeEquationFromPattern(patternStr: string): string {
  const regExp = /\[.*?\]/g
  const matchesArr = patternStr.match(regExp) || []

  matchesArr.forEach((item: string) => {
    const tempItem = item
    let randomValue: string | number = ''

    item = item.slice(0, -1).slice(1) // remove the first and last characters '[' and ']'

    if (item.indexOf(',') !== -1) {
      // finding the random number from options like [2,5,10,20,30]
      const splitArr = item.split(',')
      randomValue = randomItemFromList(splitArr)
    } else if (item.indexOf('-') !== -1) {
      // finding the random number from range pattern like [1-9]
      const splitArr = item.split('-')
      randomValue = randomIntFromInterval(Number(splitArr[0]), Number(splitArr[1]))
    } else {
      randomValue = item.trim()
    }
    patternStr = patternStr.replace(tempItem, typeof randomValue == 'string' ? randomValue : randomValue.toString())
  })

  return patternStr
}
